/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_PrivacyInputs */

const vi_einvoice_credential_privacy = /** @type {(inputs: Einvoice_Credential_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mật khẩu được mã hóa khi lưu và không bao giờ hiển thị lại.`)
};

/**

* @param {Einvoice_Credential_PrivacyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_privacy = /** @type {((inputs?: Einvoice_Credential_PrivacyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_PrivacyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_privacy(inputs)
});